import "./SectionHeader.scss";

interface SectionHeaderProps {
  tag: string;
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}

const SectionHeader = ({
  tag,
  title,
  subtitle,
  centered = false,
  className = "",
}: SectionHeaderProps) => {
  return (
    <div className={`sectionHeader ${centered ? "centered" : ""} ${className}`}>
      <div className="sectionTag fi">{tag}</div>
      <h2
        className="sectionTitle fi"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      {subtitle && <p className="sectionSubtitle fi">{subtitle}</p>}
    </div>
  );
};

export default SectionHeader;
